"use strict";
// @ts-ignore
try {
    self['workbox:core:7.0.0'] && _();
}
catch (e) { }
